export default "__VITE_ASSET__ec3063c6__"